import axios from 'axios'

export default {
  list(params) {
    return axios.get('/users', { params }).then(response => {
      return { success: true, data: response.data }
    }, response => {
      throw { success: false, errors: response }
    })
  },
  get(params) {
    return axios.get('/users/' + params.id, { params }).then(response => {
      return { success: true, data: response.data }
    }, response => {
      throw { success: false, errors: response.errors }
    })
  },
  save(data) {
    return axios.post('/users', data).then(response => {
      return { success: true }
    }, response => {
      throw { success: false, errors: response.errors }
    })
  },
  delete(id) {
    return axios.post('/users/' + id + '/delete').then(response => {
      return { success: true }
    }, response => {
      throw { success: false, errors: response.errors }
    })
  },
  archive(id) {
    return axios.delete('/users/' + id).then(response => {
      if (response) {
        return { success: true }
      }
    }, response => {
      throw { success: false, errors: response.errors }
    })
  },
  unzip(id) {
    return axios.post('/users/' + id + '/restore').then(response => {
      if (response) {
        return { success: true }
      }
    }, response => {
      throw { success: false, errors: response.errors }
    })
  },

}
